import React from 'react';

import * as S from './styles';

export const PowerReviewsDisplay = ({ id }: { id: string }) => (
  <S.ReviewDisplay id={id} data-testid="powerReviewsDisplay"></S.ReviewDisplay>
);

export default PowerReviewsDisplay;
